"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDelayedValue = useDelayedValue;
const react_1 = require("react");
function useDelayedValue(target, delay) {
    const [delayedVal, setDelayedVal] = (0, react_1.useState)(target);
    const timerRef = (0, react_1.useRef)();
    const unmountedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        unmountedRef.current = false;
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            if (!unmountedRef.current) {
                setDelayedVal(target);
            }
        }, delay);
        return () => {
            unmountedRef.current = true;
        };
    }, [target]);
    return delayedVal;
}
